import initialState           from './initialState';
import * as reducerGeneratorDocsManager  from './manager/config/reducerGenerator';
import * as reducerGeneratorDocsWorkspace  from './workspace/config/reducerGenerator';
import * as reducerGeneratorDocs from './config/reducerGenerator';
import * as reducerGeneratorShared from './shared/config/reducerGenerator';
import * as reducerGeneratorSignature from './signature/config/reducerGenerator';
import * as reducerGeneratorReportGenerator from './reportGenerator/config/reducerGenerator';

const INITIAL_STATE = ({
        ...initialState
});

export default (state = INITIAL_STATE, action) => {
  if (reducerGeneratorDocsManager[action.type])
    return reducerGeneratorDocsManager[action.type](state, action);
  if (reducerGeneratorDocsWorkspace[action.type])
    return reducerGeneratorDocsWorkspace[action.type](state, action);
  if(reducerGeneratorDocs[action.type])
    return reducerGeneratorDocs[action.type](state, action);
  if(reducerGeneratorShared[action.type])
    return reducerGeneratorShared[action.type](state, action);
  if(reducerGeneratorSignature[action.type])
    return reducerGeneratorSignature[action.type](state, action);
  if(reducerGeneratorReportGenerator[action.type])
    return reducerGeneratorReportGenerator[action.type](state, action);
  else
    return state;
};